<template>
  <div class="wrap-alert-conten-dump">
    <v-card class="d-flex pa-1 bg" outlined>
      <div class="mr-auto d-flex">
        <system-linked-combo v-model="select" hide-stack></system-linked-combo>
      </div>
    </v-card>
    <v-row>
      <v-col cols="4">
        <v-data-table :headers="headers" :items="cloneDumpList" item-key="name" :loading="loadings.table" @click:row="selectRow" :single-select="true" class="elevation-1 content" height="600" dense fixed-header disable-pagination hide-default-footer></v-data-table>
      </v-col>
      <v-col cols="8">
        <v-data-table :headers="subHeaders" :items="cloneDumpItems" item-key="name" :loading="loadings.subTable" class="elevation-1 content" height="600" dense fixed-header disable-pagination hide-default-footer>
          <template v-slot:top>
            <AlertUser ref="dumpAlertUserComp" :userFormData="formItem" dscType="abapDump" />
          </template>
          <template v-slot:item.active="{ item }">
            <v-checkbox v-model="checkedVm" :id="item.code" :value="item.code" @click="chkChange(item)" hide-details class="check-margin" dense></v-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn v-if="item.active" x-small max-height="20" @click="openAlertUser(item)">
              <v-icon small left color="primary">mdi-bell-plus-outline</v-icon>
              <span v-html="$t('alert.user.settings')" />
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import AlertUser from './components/AlertUser';

export default {
  name: 'Dump',
  components: {
    AlertUser,
  },
  data() {
    return {
      loadings: {
        table: true,
        subTable: true,
      },
      select: { stack: 'ABAP', system: '' },
      cloneDumpList: [],
      cloneDumpItems: [],
      formItem: {},
      childParams: {
        systemId: '',
        category: '',
      },
      checkedVm: [],
      dumpSapDataCode: 'ABAPDUMP',
      currentChk: '',
    };
  },
  computed: {
    ...mapState('preference/alert', ['abapDumpList', 'abapDumpItem', 'addDumpStatus', 'deleteDumpStatus']),
    headers() {
      const headers = [{ text: this.$t('alert.abap.category'), value: 'name', sortable: false }];
      return headers;
    },
    subHeaders() {
      const headers = [
        { text: this.$t('alert.abap.errid'), value: 'code', sortable: false },
        { text: this.$t('alert.active'), value: 'active', width: '14%', sortable: false },
        { text: '', value: 'actions', width: '20%', sortable: false },
      ];

      return headers;
    },
  },
  watch: {
    'select.system'(val) {
      this.childParams.systemId = val;
    },
    abapDumpList(value) {
      this.cloneDumpList = _.cloneDeep(value);
      this.$nextTick(() => {
        this.childParams.category = value[0].category;
        this.loadings.table = false;
      });
    },
    childParams: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          if (val.category && val.systemId) this.fetchDumpItem();
        });
      },
    },
    abapDumpItem(value) {
      this.cloneDumpItems = _.cloneDeep(value);
      this.checkedVm = _.map(_.reject(this.cloneDumpItems, ['active', false]), 'code');
      this.$nextTick(() => {
        this.loadings.subTable = false;
      });
    },
    addDumpStatus(value) {
      this.isSucess('add', value);
    },
    deleteDumpStatus(value) {
      this.isSucess('del', value);
    },
  },
  created() {
    this.initBaseData();
  },
  methods: {
    initBaseData() {
      //fetchSystems
      this.$store.dispatch('preference/alert/abapDumps');
    },
    fetchDumpItem() {
      this.loadings.subTable = true;
      this.cloneDumpItems = [];
      const params = this.childParams;
      this.$store.dispatch('preference/alert/abapDump', params);
    },
    deleteAbapDump() {
      const params = {
        systemId: this.childParams.systemId,
      };
      this.$store.dispatch('preference/alert/deleteAbapDump', params);
    },
    selectRow(item, row) {
      if (!row.isSelected) row.select(true);
      this.childParams.category = item.category;
    },
    chkChange(item) {
      this.currentChk = item.code;
      const params = {
        systemId: this.childParams.systemId,
        sapDataCode: this.dumpSapDataCode,
        alertCode: item.code,
      };
      if (item.active) {
        this.$store.dispatch('preference/alert/deleteAbapDump', params);
      } else {
        this.$store.dispatch('preference/alert/addAbapDump', params);
      }
    },
    isSucess(sts, val) {
      const tempIdx = el => el.code === this.currentChk;
      let fiIdx = this.cloneDumpItems.findIndex(tempIdx);
      if (val === 'success') {
        sts === 'del' ? (this.cloneDumpItems[fiIdx].active = false) : (this.cloneDumpItems[fiIdx].active = true);
      } else if (val === 'error') {
        this.fetchDumpItem();
      } else {
        return false;
      }
    },
    openAlertUser(item) {
      const openParams = {
        systemId: this.childParams.systemId,
        sapDataCode: this.dumpSapDataCode,
        alertCode: item.code,
      };
      this.formItem = openParams;
      this.$refs.dumpAlertUserComp.$data.userShow = true;
    },
  },
};
</script>
<style lang="scss">
.check-margin {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0;
  .v-input--selection-controls__input {
    margin: 0 auto !important;
  }
}
</style>
